export interface RunningJobs {
    export_name?: string,
    export_id?: string,
    file_url?: string,
    task_name: string,
    task_id: string,
    status: number,
    type: number,
    startedAt: number,
    elapsedTime: number,
    progress: number,
    result_data?: unknown,
    group_id?: string,
    set_to_stop: boolean,
    timer: number,
    static_progress_count: number,
    internalCallback?: (taskId: string) => void,
}

export interface JobRequest {
    job_type: string;
    user_created_id: string;
    account_id: string;
    additional_params: unknown;
}

export interface JobScheduleResult {
    status: number;
    jobId: string;
    error?: string;
    stackTrace?: string;
}

export interface JobResult {
    job_id: string;
    result: unknown;
    error?: string;
    stack_trace?: string;
}

export interface TaskGroup {
    id: string,
    name: string,
    progress: number,
    startedAt: number,
    elapsedTime: number,
    total: number,
    done: string[],
    errored: string[],
    tasks: RunningJobs[]
}

export interface QRCodeGenerationJobResult {
    status: boolean;
    url: string;
    markers_processed: string;
    markers_failed: string;
    total: string;
}


export const STATIC_PROGRESS_LIMIT = 5;

export const AdminJobTypes = {
    Test: 0,
    MarkerOperations: 106,
    QRCodeGeneration: 30,
};

export enum StatusTypes {
    Enqueued = 'ENQUEUED',
    Running = 'RUNNING',
    Error = 'ERROR',
    Complete = 'COMPLETE'
}